<template>
	<div class="private-order-banner">
		<img
			src="https://cdn.ostock.id/img/wholesale-order-title-desc.webp"
			alt=""
			class="banner-title"
		/>

		<div class="banner-search-wrapper">
			<private-order-search-bar v-if="searchBarPos === 'page'" placeholder="Cari Produk" />
		</div>

		<img src="https://cdn.ostock.id/img/wholesale-banner-only.webp" alt="" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import PrivateOrderSearchBar from '@/components/private-orders/homepage/SearchBar.vue';

export default {
	components: {
		PrivateOrderSearchBar,
	},
	computed: {
		...mapGetters({
			searchBarPos: 'privateOrder/searchBarPos',
		}),
	},
};
</script>

<style scoped lang="scss">
.private-order-banner {
	position: relative;
	display: flex;
	justify-content: center;
}

img.banner-title {
	position: absolute;
	width: 35%;
	top: 12%;
}

.banner-search-wrapper {
	position: absolute;
	top: 58%;
	width: 300px;
	height: 35px;

	@media screen and (min-width: 992px) {
		width: 40%;
		height: 45px;
	}

	@media screen and (min-width: 1200px) {
		height: 55px;
	}
}
</style>
